/** 文案截断与按宽度折行。不依赖 Canvas 以外的测量函数，方便单测。 */

export function truncateRunes(value: string, max: number): string {
  const chars = Array.from(value)
  if (chars.length <= max) return value
  if (max <= 1) return '…'
  return chars.slice(0, max - 1).join('') + '…'
}

/**
 * 按测量宽度折行。超出 maxLines 时最后一行以省略号结尾。
 */
export function wrapLines(
  text: string,
  maxWidth: number,
  measure: (line: string) => number,
  maxLines: number,
): string[] {
  const normalized = text.replace(/\r\n/g, '\n').trim()
  if (!normalized || maxLines <= 0 || maxWidth <= 0) return []

  const all: string[] = []
  for (const paragraph of normalized.split('\n')) {
    const chars = Array.from(paragraph)
    if (chars.length === 0) continue
    let current = ''
    for (const ch of chars) {
      const next = current + ch
      if (current && measure(next) > maxWidth) {
        all.push(current)
        current = ch
      } else {
        current = next
      }
    }
    if (current) all.push(current)
  }

  if (all.length <= maxLines) return all
  const kept = all.slice(0, maxLines)
  let last = kept[maxLines - 1] || ''
  while (last && measure(last + '…') > maxWidth) {
    const chars = Array.from(last)
    chars.pop()
    last = chars.join('')
  }
  kept[maxLines - 1] = `${last}…`
  return kept
}
